<template>
  <div>
    <v-container fluid class="py-0">
      <v-row>
        <v-card flat color="transparent" class="mx-auto py-6 text-center">
          <v-card-title class="display-1 mb-2">{{ $t("solution.title") }}</v-card-title>
          <v-card-subtitle class="subtitle-1">SOLUTION</v-card-subtitle>
        </v-card>
      </v-row>
      <v-row class="text-center" align="start">
        <v-spacer></v-spacer>
        <v-col :cols='isMobile?12:"false"'>
          <v-card class="mb-4" flat tile color="transparent">
            <v-card-title :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap justify-center"' v-html="$t('solution.content')">{{ $t('solution.content') }}</v-card-title>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row v-for="(item,index) in $t('solution.solutions')" :key="index" >
        <v-spacer class="d-none d-sm-flex" color="blue"></v-spacer>
        <v-col class="pa-0">
          <tci-slide-btn-card :desc="item" :jumpTo=solutions[index].jumpTo :color ="index%2===0?'#153967':'#15283D'" :imgSrc='require("../assets/solution/l"+(index+1)+".png")' :contents=solutions[index].icon_titles>
          </tci-slide-btn-card>
        </v-col>
        <v-col class="d-none d-sm-flex pa-0">
          <v-card class="ml-0 auto-mx" tile flat>
            <v-img class="d-sm-none d-md-flex" height="200" width="600" :src='"../assets/solution/r"+(index+1)+".jpg"'></v-img>
            <v-img class="d-none d-sm-flex d-md-none" height="200" width="400" :src='"../assets/solution/r"+(index+1)+".jpg"'></v-img>
            <v-card-text>{{ item }}</v-card-text>
          </v-card>
        </v-col>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
      </v-row>
    </v-container>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciContactFooter from "@/components/TciContactFooter.vue";
import TciSlideBtnCard from "@/components/TciSlideBtnCard.vue";

export default {
  name: "CompanyService",
  components: {
    "tci-contact-footer": TciContactFooter,
    "tci-slide-btn-card": TciSlideBtnCard
  },
  data: () => ({
    solutions: [
      {"icon_titles":["FLEXSCHE APS"],"jumpTo":"/solution-aps"},
      {"icon_titles":["MES"],"jumpTo":"/solution-mes"},
      {"icon_titles":["A+B+C"],"jumpTo":"/solution-crm"},
      {"icon_titles":["IoT"],"jumpTo":"/solution-Iot"},
      {"icon_titles":["RPA"],"jumpTo":"/solution-rpa"}
    ],
    isMobile:false
  }),
  methods:{

  },
  mounted() {
    this.isMobile = this.$vuetify.breakpoint.xs;
  }
};
</script>
